import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var PricesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default PricesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Prices/PricesReduxProps.ts
// module id = 551
// module chunks = 0